import React, { useState } from "react";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import { convertThenFormat } from "../../common-data/Converts";

const PartialCards = ({
  partialStatsData,
  prevAllFilters,
  prevSetAllFilters,
}) => {
  const [activeCard, setActiveCard] = useState("");

  function onClickCard(cardName) {
    setActiveCard(activeCard === cardName ? "" : cardName);

    prevSetAllFilters((prevs) => ({
      ...prevs,
      selFilterType: prevs.selFilterType === cardName ? "" : cardName,
    }));
  }

  return (
    <div className="cards-container cards-grid-container grid-4 mt-2rem">
      <DashboardCard
        tagName={"pending-partial-payments"}
        filterType={"today"}
        cardLabel={"Today"}
        value={`₹${convertThenFormat(partialStatsData?.total_today || 0)}`}
        onClickCard={onClickCard}
        isActiveCard={
          activeCard && prevAllFilters.selFilterType && activeCard === "today"
        }
      />
      <DashboardCard
        tagName={"pending-partial-payments"}
        filterType={"all"}
        cardLabel={"Total Pending"}
        value={`₹${convertThenFormat(partialStatsData?.total_pending || 0)}`}
        onClickCard={onClickCard}
        isActiveCard={
          activeCard && prevAllFilters.selFilterType && activeCard === "all"
        }
      />
      <DashboardCard
        tagName={"pending-partial-payments"}
        filterType={"upcoming"}
        cardLabel={"Total Upcoming"}
        value={`₹${convertThenFormat(partialStatsData?.total_upcoming || 0)}`}
        onClickCard={onClickCard}
        isActiveCard={
          activeCard &&
          prevAllFilters.selFilterType &&
          activeCard === "upcoming"
        }
      />
      <DashboardCard
        tagName={"pending-partial-payments"}
        filterType={"overdue"}
        cardLabel={"Total Overdue"}
        value={`₹${convertThenFormat(partialStatsData?.total_overdue || 0)}`}
        onClickCard={onClickCard}
        isActiveCard={
          activeCard && prevAllFilters.selFilterType && activeCard === "overdue"
        }
      />
    </div>
  );
};

export default PartialCards;
